var _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSafari = function SvgSafari(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 40,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    opacity: 0,
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.685 26.7a13.048 13.048 0 01-1.29 2.32 11.787 11.787 0 01-1.662 2.009 3.224 3.224 0 01-2.136.941 5.354 5.354 0 01-1.974-.47 5.662 5.662 0 00-2.124-.47 5.854 5.854 0 00-2.185.47 5.878 5.878 0 01-1.888.5 3.036 3.036 0 01-2.185-.966 12.377 12.377 0 01-1.738-2.08 14.385 14.385 0 01-1.838-3.654 13.371 13.371 0 01-.772-4.352 7.948 7.948 0 011.044-4.158 6.122 6.122 0 012.186-2.211 5.88 5.88 0 012.955-.834 6.958 6.958 0 012.286.532 7.348 7.348 0 001.813.533 10.848 10.848 0 002.01-.628 6.645 6.645 0 012.732-.482 5.8 5.8 0 014.545 2.39 5.056 5.056 0 00-2.681 4.593 5.067 5.067 0 001.664 3.817 5.467 5.467 0 001.662 1.09q-.2.58-.424 1.113zM25.054 8.48a5.12 5.12 0 01-1.313 3.358 4.472 4.472 0 01-3.714 1.833 3.737 3.737 0 01-.028-.455 5.26 5.26 0 011.394-3.393 5.361 5.361 0 011.7-1.273A5.058 5.058 0 0125.029 8a4.359 4.359 0 01.025.48z",
    fill: "#b3b3b3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0,
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.398 27.6A10.679 10.679 0 019.25 20a10.681 10.681 0 013.148-7.6 10.682 10.682 0 017.6-3.149 10.68 10.68 0 017.6 3.149 10.681 10.681 0 013.148 7.6 10.679 10.679 0 01-3.148 7.6 10.68 10.68 0 01-7.6 3.149 10.682 10.682 0 01-7.6-3.149zM10.75 20a9.26 9.26 0 009.251 9.248A9.259 9.259 0 0029.249 20a9.26 9.26 0 00-9.248-9.251 9.261 9.261 0 00-9.251 9.252zm4.137 5.112a.75.75 0 01-.143-.861l3-6.163a.763.763 0 01.347-.347l6.166-3a.755.755 0 01.328-.075.736.736 0 01.53.221.755.755 0 01.146.858l-3 6.166a.743.743 0 01-.347.344l-6.166 3a.765.765 0 01-.328.075.75.75 0 01-.533-.217zM19.001 20a1 1 0 001 1 1 1 0 001-1 1 1 0 00-1-1 1 1 0 00-1 1.001z",
    fill: "#7c7c7c"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSafari, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/safari.a87da0d3.svg";
export { ForwardRef as ReactComponent };